// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons[data-v-25fe5d3b]{display:flex;justify-content:center}pre[data-v-25fe5d3b]{white-space:pre-wrap;font-family:monospace;margin:0;padding:1rem;background-color:#f8f8f8;border-radius:4px}", ""]);
// Exports
module.exports = exports;
